import { SlideAction, TutorialSlide } from "../../tutorial.models";

export const OLD_USER_LOGIN: TutorialSlide[] = [
    {
        key: 'Welcome-Back',
        title: 'Learn How to Use MedicAI',
        messages: [
            { text: "In order to help you gain more out of MedicAI and ultmately help you save hours per week on admin tasks, we have introduced a guided tutorial.  We strongly recommend you engage." },
            { text: "You will need approximately 30 minutes to complete this", class: 'primary' }

        ],
        dimensions: { width: '450px' },
        actionsClass: 'button-row',
        hideDoNotShowAgain: true,
        actions: [
            {
                text: 'Now',
                color: 'primary',
                actionName: SlideAction.OLD_LOGIN_CONFIRM_NOW,
            },
            {
                text: 'Later',
                color: 'secondary',
                type: 'link',
                actionName: SlideAction.CLOSE_TUTORIAL
            },
            {
                text: 'Never',
                color: 'warn',
                type: 'link',
                actionName: SlideAction.OLD_LOGIN_CONFIRM_NEVER
            },
        ],
        position: { x: 700, y: 350 },
    },
];